"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enforceDefaultClientOptions = enforceDefaultClientOptions;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

function enforceDefaultClientOptions(AblyRealtime) {
  return /*#__PURE__*/function (_AblyRealtime) {
    (0, _inherits2.default)(Realtime, _AblyRealtime);

    function Realtime(providedOptions) {
      (0, _classCallCheck2.default)(this, Realtime);
      var clientOptions = Object.assign({
        environment: 'hubspot',
        fallbackHosts: ['hubspot-a-fallback.ably-realtime.com', 'hubspot-b-fallback.ably-realtime.com']
      }, providedOptions);
      return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Realtime).call(this, clientOptions));
    }

    return Realtime;
  }(AblyRealtime);
}